module.exports = __webpack_public_path__ + "img/guide9.b8cf7039.jpg";